import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios'

export const client: AxiosInstance = axios.create({
  baseURL: '/api/v1',
  // 不设客户端超时（0 = 无限等待）。审计日志的大范围查询、导出计数预检，
  // 以及归档导出逐条从 RustFS 拉取 blob 原文（1k 行可达数十秒），都可能远
  // 超任何固定短超时。原先的 15s 全局超时会在后端仍在正常处理时把请求
  // abort 掉，前端误报「导出失败/查询失败」。这里交由后端与浏览器/反代的
  // 超时来兜底，不在客户端层提前掐断。
  timeout: 0,
  headers: { 'Content-Type': 'application/json' },
})

client.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('guardrail_token')
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  const savedUser = localStorage.getItem('guardrail_user')
  if (savedUser && config.headers) {
    try {
      const u = JSON.parse(savedUser)
      config.headers['X-Tenant-Id'] = u.tenant_id || ''
      config.headers['X-User-Id'] = u.id || ''
      config.headers['X-User-Role'] = u.role || 'user'
    } catch { /* ignore */ }
  }
  return config
})

interface ApiResponse<T = unknown> {
  code: number
  message: string
  data: T
}

const AUTH_FREE_PATHS = ['/login', '/auth/sso', '/setup']

function handleUnauthorized() {
  if (AUTH_FREE_PATHS.some((p) => window.location.pathname.startsWith(p))) {
    return
  }
  localStorage.removeItem('guardrail_token')
  localStorage.removeItem('guardrail_refresh_token')
  localStorage.removeItem('guardrail_user')
  window.location.href = '/login'
}

client.interceptors.response.use(
  (response) => {
    const data = response.data
    if (data == null || typeof data !== 'object' || !('code' in data)) {
      return response
    }
    const apiResponse = data as ApiResponse
    if (apiResponse.code === 0) {
      response.data = apiResponse.data
    } else {
      if (apiResponse.code === 401) {
        handleUnauthorized()
      }
      return Promise.reject({
        status: response.status,
        code: apiResponse.code,
        message: apiResponse.message,
      })
    }
    return response
  },
  async (error) => {
    if (error.response?.status === 401) {
      handleUnauthorized()
    }
    return Promise.reject(error)
  },
)
